import React from 'react';
import IconContainer from '../IconContainer';
import ClockIcon from 'images/icons/shipping.svg?react-svg';
import margin from 'scy/margin.mod.scss';

export default function Icon() {
  return (
    <IconContainer marginClass={margin.right_sm}>
      <ClockIcon width={24} height={24} />
    </IconContainer>
  );
}
